import React from 'react';
import { ButtonProps } from 'antd';
import { CustomButton } from './styles';

interface PrimaryButtonProps extends ButtonProps {
	children: string;
}

export const PrimaryButton: React.FC<PrimaryButtonProps> = ({ children, ...props }) => (
	<CustomButton type="primary" {...props}>
		{children}
	</CustomButton>
);
